<script lang="ts">
    export let mode: string = 'standard';

</script>

<div class="filter-item {mode}">
    <slot />
</div>

<style>
    .filter-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: #e5f1fd;
        border-radius: 14px;
        min-height: 26px;
        font-size: var(--font-size-tactical-plan);
    }

    .action {
        background-color: #FFF4D6;
        padding: 1px 12px;
    }
    .filter-item.vehicle {
        background-color: #e5e3e3;
        padding: 0 6px;
    }

    .standard {
        /*background-color: #e0e0e0;*/
        background-color: #f7f7f7;
        /*background-color: #1c5dc7;*/
    }

    :global(.action .input-small),
    :global(.vehicle .input-small),
    :global(.standard .input-small) {
        background-color: transparent !important;
        border: 0 !important;
        font-size: 15px !important;
        padding: 2px 4px;
    }
</style>